export const BulkModifiersListColConfig = [
  {
    name_of_db_column: 'bulkModifierName',
    label_of_column: 'MODIFIER NAME',
    order_of_column: 1,
    filterable: true,
  },
  {
    name_of_db_column: 'noOfStores',
    label_of_column: '# OF STORES',
    order_of_column: 2,
    filterable: true,
  },
  {
    name_of_db_column: 'createdAt',
    label_of_column: 'CREATION DATE',
    order_of_column: 3,
    filterVariant: 'dateRange',
    initialSize: 330,
    filterable: true,
  },
  {
    name_of_db_column: 'scheduledAt',
    label_of_column: 'SCHEDULED DATE',
    order_of_column: 4,
    filterVariant: 'dateRange',
    initialSize: 330,
    filterable: true,
  },
  {
    name_of_db_column: 'status',
    label_of_column: 'STATUS',
    order_of_column: 5,
    filterable: true,
  },
]
